import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, Inject, ChangeDetectorRef, NgZone, NgModule } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as echarts from 'echarts';
import 'echarts-gl';
import { BackendApiService } from '../../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../../app/services/base-url-constants.service';
import { MatFormField, MatFormFieldControl, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatDatepicker, MatDatepickerModule, MatDatepickerToggle, MatDateRangeInput } from '@angular/material/datepicker';
import { FormsModule, NgModel } from '@angular/forms';
import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms'; 
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';

export interface FFTFileData {
  chartXdata: { x: number, y: number }[];
  labelx: string;
  chartYdata: { x: number, y: number }[];
  labely: string;
  chartZdata: { x: number, y: number }[];
  labelz: string;
  min: number;
  max: number;
  error: string;
  created_at: string;
}

export interface APIResponse {
  data: {
    code: number;
    status: string;
    message: string;
    body: FFTFileData[];
  }
}


@Component({
  selector: 'app-waterfall-plot',
  standalone: true,
  imports: [CommonModule,MatFormField,MatLabel,MatDatepickerToggle,MatDatepicker,FormsModule,MatDatepickerModule,CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WaterfallPlotComponent),
      multi: true
    }
  ],
  template: `
  <div #chartDiv class="chart-container">
    <!-- Loader overlay shown only until data is loaded -->
    <div *ngIf="!isDataLoaded" class="loader">Loading...</div>
  </div>
  <div class="main-container-waterfall">
    <div class="content-row">
      <div class="date-picker-container">
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate" (dateChange)="onDateChange()">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate" (dateChange)="onDateChange()">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
        <div class="xScale_button_container">
          <button class="active2" (click)="loadChartData()" [disabled]="!startDate || !endDate" style="margin-bottom: 22px !important; height: 42px !important" >Load Data</button>
        </div>
      </div>
      <div class="right-container">
        <div class="xScale_button_container">
          <button class="active2 custom-btn"  mat-button (click)="closeDialog()">Close</button>
        </div>
      </div>
    </div>
    <div class="subnote">
      <small>
      The chart is fully interactive – you can zoom in/out with your scroll wheel, pan by holding scroll wheel. You can also enable or disable series (Axial, Tangential, and Radial) by clicking on the legend at the top.
      </small>
    </div>
  </div>
`,
styles: [`
  .main-container-waterfall {
    padding: 12px;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    border: 1px solid gray;
    width: 100%;
  }
  .content-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 15px;
  }

  .date-picker-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .right-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    max-width: 50%;
  }
  .chart-container {
    position: relative;
    width: 100%;
    height: 80%;
    border: 2px solid #ccc;
  }
  .loader {
    position: absolute;
    z-index: 9999;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #333;
  }
  .subnote {
    text-align: center;
    font-size: 12px;
    color: #666;
    margin-top: 10px;
  }
  .close-button-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
  }
  .close-button-container button {
    border: none;
    color: white;
    padding: 0px 20px;
    margin: 5px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    background-color: #6c757d;
  }
  .custom-btn {
  margin-bottom: 22px;
  height: 42px;
  padding: 20px 20px;
 justify-content: center;
 display: flex;
  align-items: center;
}
  .close-button-container button:hover {
    opacity: 0.8;
  }
`]
})
export class WaterfallPlotComponent implements OnInit, AfterViewInit {
  startDate: Date | null = null;
  endDate: Date | null = null;
  @ViewChild('chartDiv', { static: false }) chartDiv!: ElementRef;
  chartOptions: echarts.EChartsOption | undefined;
  chartInstance!: echarts.ECharts;
  // When data is not yet loaded, isDataLoaded is false so the loader shows
  isDataLoaded = false;

  public apiUrl = BaseUrlConstantsService.BASE_DIAGNOSTICS + "diagnostics/waterfall-fftChart/";
  // Color definitions
  lineColorAxial = '#28a745';
  lineColorTangential = '#dc3545';
  lineColorRadial = '#007bff';

  areaColorAxial = 'rgba(40, 167, 69, 0.3)';
  areaColorTangential = 'rgba(220, 53, 69, 0.3)';
  areaColorRadial = 'rgba(0, 123, 255, 0.3)';

  userId: number;
  fftCollection: any[] = [];
  assetId: number;
  inventoryId: number;
  rawData: any[] = [];
  dateSeries: any[] = [];

  constructor(
    private service: BackendApiService,
    private cd: ChangeDetectorRef,
    private zone: NgZone,
    public dialogRef: MatDialogRef<WaterfallPlotComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userId = data.userId;
// console.log(data.fftCollection)
    data.fftCollection.slice(0,10).forEach(element => {
     this.fftCollection.push(element.id)
     this.dateSeries.push(element.time)
    });

    // this.fftCollection = data.fftCollection.slice(0,5);
    this.assetId = data.assetId;
    this.inventoryId = data.inventoryId;
    // console.log("userId: " + this.userId);
    // console.log("assetId: " + this.assetId);
    // console.log("inventoryId: " + this.inventoryId);
    // console.log("fftCollection: " + this.fftCollection);
    // console.log(this.dateSeries);
    // console.log(this.fftCollection);
  }

  async fetchFFTData(): Promise<FFTFileData[]> {
    const endpoint = this.apiUrl + `${this.assetId}/${this.inventoryId}`;
    const reqBody = {
      userId: this.userId,
      fftArray: this.fftCollection,
      type: "velocity"
    };
    try {
      const res = await this.service.postData(endpoint, reqBody);
      const response: APIResponse = JSON.parse(JSON.stringify(res));
      if (response.data.status === "success") {
        return response.data.body;
      } else {
        this.service.showError("Something went wrong");
        return [];
      }
    } catch (error: any) {
      this.service.showError("Something went wrong");
      console.error("API fetch error:", error);
      return [];
    }
  }
  onDateChange(): void {
    if (this.startDate && this.endDate) {
      const filteredData = this.data.fftCollection
        .filter((element: any) => {
          const elementDate = new Date(element.time);
          return elementDate >= this.startDate! && elementDate <= this.endDate!;
        })
        .sort((a: any, b: any) => new Date(a.time).getTime() - new Date(b.time).getTime())
        .slice(0, 10);

      this.fftCollection = filteredData.map((element: any) => element.id);
      this.dateSeries = filteredData.map((element: any) => element.time);
      this.loadChartData();
    }
  }

  ngOnInit(): void {
    // No data loading in ngOnInit.
  }

  ngAfterViewInit(): void {
    // Initialize the chart instance.
    this.chartInstance = echarts.init(this.chartDiv.nativeElement);
    window.addEventListener('resize', () => {
      this.chartInstance.resize();
    });
    // Run data loading after the view is rendered.
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        this.zone.run(async () => {
          await this.loadChartData();
        });
      }, 0);
    });
  }

  async loadChartData(): Promise<void> {
    const files: FFTFileData[] = await this.fetchFFTData();
    // Sort files so that the latest date comes first
    files.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

    const mainSeries: echarts.SeriesOption[] = [];

    files.forEach((file, index) => {

      const axialData = file.chartXdata.map(pt => [pt.x, pt.y, this.dateSeries[index]]);
      const tangentialData = file.chartYdata.map(pt => [pt.x, pt.y,  this.dateSeries[index]]);
      const radialData = file.chartZdata.map(pt => [pt.x, pt.y, this.dateSeries[index]
      ]);
      mainSeries.push({
        type: 'line3D',
        name: 'Axial',
        data: axialData,
        lineStyle: { width: 2, color: this.lineColorAxial },
        areaStyle: { color: this.areaColorAxial },
        animation: true,
        animationDuration: 1000,
        animationEasing: 'cubicOut'
      } as unknown as echarts.SeriesOption);

      mainSeries.push({
        type: 'line3D',
        name: 'Tangential',
        data: tangentialData,
        lineStyle: { width: 2, color: this.lineColorTangential },
        areaStyle: { color: this.areaColorTangential },
        animation: true,
        animationDuration: 1000,
        animationEasing: 'cubicOut'
      } as unknown as echarts.SeriesOption);

      mainSeries.push({
        type: 'line3D',
        name: 'Radial',
        data: radialData,
        lineStyle: { width: 2, color: this.lineColorRadial },
        areaStyle: { color: this.areaColorRadial },
        animation: true,
        animationDuration: 1000,
        animationEasing: 'cubicOut'
      } as unknown as echarts.SeriesOption);
    });
    this.chartOptions = {
      title: { text: '3D Waterfall Chart (Date-wise Data)', left: 'center' },
      tooltip: {
        formatter: (params: any) => {
          const [freq, val, z] = params.value;
          return `<b>${params.seriesName}</b><br/>Date: ${z}<br/>Frequency: ${freq} Hz<br/>Value: ${val}`;
        }
      },
      legend: {
        data: ['Axial', 'Tangential', 'Radial'],
        orient: 'horizontal',
        left: 'center',
        top: 30,
        selectedMode: 'multiple'
      },
      xAxis3D: { type: 'value', name: 'Frequency (Hz)', min: 0 },
      yAxis3D: { type: 'value', name: 'Amplitude' },
      zAxis3D: {
        type: 'category',
        name: 'Date',
        data: this.dateSeries,
        axisLabel: { formatter: (value: string) => value }
      },
      grid3D: {
        left: '0%',
        top: '0%',
        right: '0%',
        bottom: '0%',
        boxWidth: 100,
        boxHeight: 60,
        boxDepth: 20,
        environment: null,
        axisLine: { lineStyle: { color: '#999' } },
        axisPointer: { lineStyle: { color: '#999' } },
        viewControl: {
          projection: 'perspective',
          alpha: -60,
          beta: 180,
          distance: 100,
          rotateSensitivity: 0,
          zoomSensitivity: 1,
          panSensitivity: 1,
          minDistance: 1,
          maxDistance: 2000,
          target: [0, 0, 0],
          up: [0, 1, 0]
        },
        light: { main: { intensity: 1.2 }, ambient: { intensity: 0.4 } }
      },
      series: mainSeries,
      animation: true,
      animationDuration: 2000,
      animationEasing: 'cubicOut'
    };

    // Set the chart options and mark data as loaded so that the loader is hidden.
    this.chartInstance.setOption(this.chartOptions);
    this.isDataLoaded = true;
    this.cd.detectChanges();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
